import {ChangeDetectionStrategy, Component, inject} from '@angular/core';
import {MAT_DIALOG_DATA} from '@angular/material/dialog';
import {ConfirmationDialog, ConfirmationDialogDefinition} from '@aviary/dialogs/confirmation-dialog/confirmation-dialog.types';
import {ConfirmationDialogComponent} from '@aviary/dialogs/confirmation-dialog/confirmation-dialog.component';
import {CancelEmailChangeDialogData} from '@store/patron/patron.types';

@Component({
  selector: 'px-cancel-email-change-dialog',
  template: `
    <mx-confirmation-dialog [definition]="dialogDefinition">
      <p>Your email will stay as: <span class="block max-w-full text-title-medium break-all">{{ dialogData.email }}</span></p>
      <p>The verification link we sent to {{ dialogData.pendingEmail }} will no longer work. Are you sure you wish to cancel this email change?</p>
    </mx-confirmation-dialog>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ConfirmationDialogComponent]
})
export class CancelEmailChangeDialog implements ConfirmationDialog<CancelEmailChangeDialogData> {
  public readonly dialogData: CancelEmailChangeDialogData = inject(MAT_DIALOG_DATA);

  public readonly dialogDefinition: ConfirmationDialogDefinition = {
    title: 'Cancel Email Change',
    cancelButtonLabel: 'Go Back',
    confirmButtonLabel: 'Yes, Cancel'
  };
}
